import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { de } from 'date-fns/locale';
import { ClientssoService } from 'src/app/common/services/clientsso.service';

@Component({
  selector: 'app-clientcallback',
  templateUrl: './clientcallback.component.html',
  styleUrls: ['./clientcallback.component.css'],
})
export class ClientcallbackComponent {
  constructor(
    private authService: ClientssoService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    // debugger;
    this.authService.clearStorages();

    this.authService.handleAuthCallback();
  }
}
